import React, { useEffect, useState } from "react";
import { Popover, Box, Typography } from "@mui/material";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { addCreatorRate } from "../live-campaign-repository";
import dayjs from 'dayjs';

const VideoOnDatePickerPopover = ({ anchorEl, setVideoOnAnchorEl, handleCreatorRateSave, campaignId, paymentRequest, setRateAdded, setPaymentRequest }) => {
  const open = Boolean(anchorEl);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const callApi = async () => {
      if (isUpdating) {
        await addCreatorRate(campaignId, paymentRequest, setRateAdded, setPaymentRequest);
        setVideoOnAnchorEl(null);
        setIsUpdating(false);
      }
    };
    callApi();
  }, [campaignId, paymentRequest, isUpdating, setRateAdded, setVideoOnAnchorEl, setPaymentRequest]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setVideoOnAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body1" sx={{ fontWeight: 600, mb: 3, color: '#464646', fontFamily: 'sans-serif', fontSize: '20px' }}>
            Select Video Submit Date
          </Typography>

          <Box
            sx={{
              border: "2px solid #E0E0E0",
              borderRadius: "8px",
              overflow: "hidden"
            }}
          >
            <DateCalendar
              value={
                paymentRequest.videoOnDate
                  ? dayjs(paymentRequest.videoOnDate)
                  : dayjs()
              }
              onChange={(newDate) => {
                const formattedDate = dayjs(newDate).format('YYYY-MM-DD');
                setIsUpdating(true);
                handleCreatorRateSave("videoOnDate", formattedDate);
              }}
            />
          </Box>
        </Box>
      </Popover>
    </LocalizationProvider>
  );
};

export default VideoOnDatePickerPopover;
